<template>
  <generic-modal :title="$t('details')" ref="generic_modal">
    <div class="title is-5">
      {{ $t("process") }} {{ request.sirc_process_number }}
    </div>
    <div class="subtitle is-6">
      {{ format_date_time(request.create_date) }} -
      {{ translate_status(request.status_code) }}
    </div>
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          ref="request_tab"
          class="is-active"
          data-tab="request"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="angle right icon" aria-hidden="true"></i>
            <span>{{ $t("request") }}</span>
          </a>
        </li>
        <li data-tab="response" @click="change_active_tab($event, this)">
          <a>
            <i class="angle left icon" aria-hidden="true"></i>
            <span>{{ $t("response") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="container" ref="contents">
      <div
        class="is-active"
        data-tab="request"
        v-if="request && request.profile"
      >
        <!-- <div class="title is-5">
          {{ $t("profile") }} {{ request.profile.name }}
        </div> -->
        <!-- <div class="title is-6">
          {{ $t("request data") }}
        </div> -->
        <pre>{{ JSON.stringify(request.data, null, 2) }}</pre>
      </div>
      <div class="is-hidden" data-tab="response">
        <!-- <div class="title is-5">
          {{ $t("response date") }}:
          {{ format_date_time(request.response_date) }}
        </div>
        <div class="title is-6">
          {{ $t("request data") }}
        </div> -->
        <pre v-if="request.json_response">{{
          JSON.stringify(request.json_response, null, 2)
        }}</pre>
      </div>
    </div>

    <!-- <pre>{{ request }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  change_active_tab,
  generate_error_message_text,
  get,
  format_date_time,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "SircRequestDetailModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      request: {},
      error: "",
    };
  },
  computed: {},
  methods: {
    change_active_tab: change_active_tab,
    format_date_time,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
      v.$root.loader(true);
      get("/sirc/request", { uuid: uuid })
        .then((res) => {
          v.request = res;
          window.jQuery(v.$refs.request_tab).click();
        })
        .catch((err) => {
          v.error = generate_error_message_text(err);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.request = {};
      v.error = "";
    },
    translate_status(status) {
      let v = this;
      switch (status) {
        case "C":
          return v.$t("created");
        case "P":
          return v.$t("processed");
        case "E":
          return v.$t("errored");
        default:
          return status;
      }
    },
  },
  mounted() {},
  created() {},
  watch: {},
};
</script>
<style></style>
